import { LitElement, html, css } from 'lit'
import { StoreMixin } from '../store.js'
import { navigate } from '../router.js'
import { api } from '../api.js'
import { toast } from './app-toast.js'

// Client-organization admin list (§6.3, Phase 4). Agent-only (route guards). Each
// row links to the detail view where domains + members are managed.
class PageClients extends StoreMixin(LitElement) {
  static properties = {
    _clients: { state: true },
    _loading: { state: true }
  }

  static styles = css`
    :host { display: block; }
    h1 { color: var(--bx-brand); margin: 0 0 0.25rem; font-size: 1.4rem; }
    p.lede { color: var(--bx-muted); margin: 0 0 1rem; }
    .list { background: var(--bx-surface); border: 1px solid var(--bx-border); border-radius: var(--bx-radius);
            box-shadow: var(--bx-shadow); overflow: hidden; }
    .row { display: grid; grid-template-columns: 1fr auto; gap: 0.5rem 1rem; align-items: center;
           padding: 0.85rem 1rem; border-bottom: 1px solid var(--bx-border); cursor: pointer; }
    .row:last-child { border-bottom: none; }
    .row:hover { background: var(--bx-bg); }
    .name { font-weight: 600; color: var(--bx-ink); }
    .domains { color: var(--bx-muted); font-size: 0.85rem; margin-top: 0.15rem; }
    .meta { text-align: right; font-size: 0.82rem; color: var(--bx-muted); white-space: nowrap; }
    .warn { color: #b45309; }
    .empty, .loading { padding: 3rem; text-align: center; color: var(--bx-muted); }
  `

  constructor() {
    super()
    this._clients = []
    this._loading = true
  }

  connectedCallback() {
    super.connectedCallback()
    this._load()
  }

  async _load() {
    this._loading = true
    try {
      this._clients = await api.get('/clients')
    } catch (err) {
      toast(err.message || 'Failed to load clients', 'error')
    } finally {
      this._loading = false
    }
  }

  render() {
    if (this._loading) return html`<div class="loading">Loading…</div>`
    return html`
      <h1>Clients</h1>
      <p class="lede">Client organizations. Manage each company's email domains and members.</p>
      ${this._clients.length ? html`
        <div class="list">
          ${this._clients.map(c => html`
            <div class="row" @click=${() => navigate(`/clients/${c.id}`)}>
              <div>
                <div class="name">${c.name}</div>
                <div class="domains">
                  ${c.domains.length ? c.domains.map(d => d.domain).join(', ') : 'No domains'}
                  ${c.workamajigCompanyId ? '' : html`<span class="warn"> · not linked to Workamajig</span>`}
                </div>
              </div>
              <div class="meta">${c.memberCount ?? 0} member${c.memberCount === 1 ? '' : 's'}</div>
            </div>`)}
        </div>` : html`<div class="empty">No client organizations yet.</div>`}
    `
  }
}

customElements.define('page-clients', PageClients)
